import * as R from 'ramda';
import B from 'bluebird';
import MainDispatcher from '../support/MainDispatcher';
import server from '../support/server';
import dash_api from '../support/dash_api';
import { APP_VIEW, APP_VIEW_ID_FIELD } from '../../common/support/viewConstants';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';

/* ------------------------------ DEPRECATED ---------------------------------
NOTE: This is an usage of our old flux implementation. While still in use in
many places, any NEW client-side state management needs with apps
should be done with Redux in:

* client/common/reducers/AppReducer
* client/common/actions/AppActions
 -------------------------------------------------------------------------- */

const errorProvider = new ErrorProvider();

export default {
  setCurrentApp: function (current_app) {
    MainDispatcher.dispatch({
      action: 'APP_LOAD',
      current_app_id: current_app.id,
      current_app: current_app,
    });
  },
  // Only used by unit tests anymore:
  setApp: function (app_id) {
    server('loggedout/app set', { next_app_id: app_id })
      .then(function () {
        location.reload();
      })
      .catch(function (err) {
        MainDispatcher.dispatch({
          action: 'ENTITY_ERROR',
          errors: errorProvider.parse(err).getMessageOrEmpty(),
        });
      });
  },
  createApp: function (data) {
    MainDispatcher.dispatch({
      action: 'APP_CREATING',
    });

    return server('loggedout/app pair create', R.omit(['apps'], data)).then(
      function (app_id) {
        return (
          dash_api
            .post('/v1/dashboard-user/set-view', {
              view: {
                current_view: APP_VIEW,
                [APP_VIEW_ID_FIELD]: app_id,
              },
            })
            // When calling from logged out screen on /create screen when user has deleted
            // their only app, the dash_api call fails but it's unneeded. Therefore
            // if it fails just do the same as if it had passed, so no need for separate
            // 'then' and 'catch' statements
            .finally(() => (window.location = '/account-settings/app'))
        );
      },
      function (err) {
        MainDispatcher.dispatch({
          action: 'ENTITY_ERROR',
          errors: errorProvider.parse(err).getMessageOrEmpty(),
          disable_notification: true,
        });
      }
    );
  },
  // data is full app object, second and third are optional
  saveSettings: function (data, disable_notification, reload) {
    MainDispatcher.dispatch({
      action: 'ENTITY_SAVING',
    });
    return server(
      'settings save',
      R.mapObjIndexed((value) => {
        return typeof value === 'string' ? value.trim() : value;
      }, R.omit(['logo_url', 'errors'], data)),
      { logo: data.logo_url, og_image: data.og_image_url }
    ).then(
      function (savedSettings) {
        MainDispatcher.dispatch({
          action: 'ENTITY_SAVED',
          app: savedSettings,
          disable_notification,
        });
        if (reload) {
          location = location.pathname;
        }
      },
      function (err) {
        MainDispatcher.dispatch({
          action: 'ENTITY_ERROR',
          error: errorProvider.parse(err).getResponse(),
        });
        return B.reject(err);
      }
    );
  },
  setLocally: function (app, pair_fields) {
    pair_fields = pair_fields || [];
    MainDispatcher.dispatch({
      action: 'ENTITY_SAVED',
      app,
      pair_fields,
      disable_notification: true,
    });
  },
  setCustomSubDomainLocally: function (subdomain) {
    MainDispatcher.dispatch({
      action: 'UPDATE_CUSTOM_SUBDOMAIN',
      subdomain,
      disable_notification: true,
    });
  },
  settingsWarning: function (warning) {
    MainDispatcher.dispatch({
      action: 'SETTINGS_WARNING',
      warning: warning,
    });
  },
  archiveApp: function (app_id) {
    server('app archive')
      .then(() => {
        MainDispatcher.dispatch({
          action: 'APP_ARCHIVED',
          app_id: app_id,
        });
      })
      .catch((err) => {
        MainDispatcher.dispatch({
          action: 'ENTITY_ERROR',
          errors: errorProvider.parse(err).getMessageOrEmpty(),
        });
      });
  },
  unarchiveApp: function (app_id) {
    server('app unarchive')
      .then(() => {
        MainDispatcher.dispatch({
          action: 'APP_UNARCHIVED',
          app_id: app_id,
        });
      })
      .catch((err) => {
        MainDispatcher.dispatch({
          action: 'ENTITY_ERROR',
          errors: errorProvider.parse(err).getMessageOrEmpty(),
        });
      });
  },
};
